<template>
    <modal @close="removeFundsPromotionCancelClick" class="edit-modal" hideFooter id="remove-funds-promotion">
        <div class="td-edit-container">
            <div class="pagination">
                <div class="form-name">
                    <h3>Remove Promotion Funds</h3>
                    <p>
                        If you remove the funds on this promotion, ${{ getCurrentBalance() }} will be credited to your account.  Your account credit can then be added to any other promotion or applied to any other services.
                    </p>
                </div>
            </div>
            <div class="edit-pages td-form">
                <div class="mb-2">
                    <h3>Remove Funds</h3>
                    <p>
                        <span><strong>Title:</strong></span><br />
                        {{ promotion.title }}
                    </p>
                    <p>
                        <span><strong>Message:</strong></span><br />
                        {{ promotion.message }}
                    </p>
                    <p>
                        <span><strong>Current balance:</strong></span><br />
                        ${{ getCurrentBalance() }}
                    </p>
                </div>
                <div class="actions">
                    <div>
                        <button class="td-btn primary-outlined" @click="removeFundsPromotionCancelClick">Cancel</button>
                    </div>
                    <div class="save-btn">
                        <button class="td-btn btn primary" @click="removeFundsPromotionSaveClick"><span v-if="isLoading"><icon name="faSpinner" type="solid" spin></icon>&nbsp;</span>Remove Funds</button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import script from './RemoveFunds';
    export default script;
</script>
<style lang="less">
    @import './RemoveFunds.less';
</style>